/**
 * @flow
 * @relayHash 1ded3181e7f245511a0dd3d7617f8035
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type ApprovalDashboardQueryVariables = {|
  first?: ?number
|};
export type ApprovalDashboardQueryResponse = {|
  +poApprovalQueue: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +poNumber: string,
        +vendor: ?{|
          +id: string,
          +vendorNumber: string,
          +name: string,
        |},
        +status: POStatus,
        +totalAmount: number,
        +requestedBy: ?{|
          +id: string,
          +firstName: string,
          +lastName: string,
        |},
        +createdAt: any,
        +lineItems: $ReadOnlyArray<{|
          +id: string,
          +item: {|
            +id: string,
            +itemNumber: string,
            +name: string,
          |},
          +quantity: number,
          +unitPrice: number,
          +totalPrice: number,
        |}>,
      |}
    |}>,
    +totalCount: number,
  |}
|};
export type ApprovalDashboardQuery = {|
  variables: ApprovalDashboardQueryVariables,
  response: ApprovalDashboardQueryResponse,
|};
*/


/*
query ApprovalDashboardQuery(
  $first: Int
) {
  poApprovalQueue(first: $first) {
    edges {
      node {
        id
        poNumber
        vendor {
          id
          vendorNumber
          name
        }
        status
        totalAmount
        requestedBy {
          id
          firstName
          lastName
        }
        createdAt
        lineItems {
          id
          item {
            id
            itemNumber
            name
          }
          quantity
          unitPrice
          totalPrice
        }
        __typename
      }
      cursor
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PurchaseOrderEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrder",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "poNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vendor",
            "storageKey": null,
            "args": null,
            "concreteType": "Vendor",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "vendorNumber",
                "args": null,
                "storageKey": null
              },
              (v2/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalAmount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "requestedBy",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "lineItems",
            "storageKey": null,
            "args": null,
            "concreteType": "PurchaseOrderLine",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "quantity",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "unitPrice",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalPrice",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "totalCount",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
      }
    ]
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ApprovalDashboardQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "poApprovalQueue",
        "name": "__ApprovalDashboard_poApprovalQueue_connection",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrderConnection",
        "plural": false,
        "selections": (v3/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ApprovalDashboardQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "poApprovalQueue",
        "storageKey": null,
        "args": (v4/*: any*/),
        "concreteType": "PurchaseOrderConnection",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "poApprovalQueue",
        "args": (v4/*: any*/),
        "handle": "connection",
        "key": "ApprovalDashboard_poApprovalQueue",
        "filters": null
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ApprovalDashboardQuery",
    "id": null,
    "text": "query ApprovalDashboardQuery(\n  $first: Int\n) {\n  poApprovalQueue(first: $first) {\n    edges {\n      node {\n        id\n        poNumber\n        vendor {\n          id\n          vendorNumber\n          name\n        }\n        status\n        totalAmount\n        requestedBy {\n          id\n          firstName\n          lastName\n        }\n        createdAt\n        lineItems {\n          id\n          item {\n            id\n            itemNumber\n            name\n          }\n          quantity\n          unitPrice\n          totalPrice\n        }\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": null,
          "direction": "forward",
          "path": [
            "poApprovalQueue"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e6e8ecf1045f24184a7b1285ae2f03d1';
module.exports = node;
